import { useEffect, useState } from "react";
import { getPendingApprovals, getDraftDetails } from "../../services/approvalApi";
import ApprovalModal from "../../components/ApprovalModal";
import StatusBadge from "../../components/StatusBadge";

export default function ApprovalDashboard() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  const load = async () => {
    const data = await getPendingApprovals();
    setItems(data);
  };

  useEffect(() => {
    load();
  }, []);

  const open = async (item: any) => {
    const detail = await getDraftDetails(item.draft_id);
    setActive({ ...item, ...detail });
  };

  return (
    <div style={{ padding: 30 }}>
      <h1>Approval Dashboard</h1>

      <table width="100%">
        <thead>
          <tr>
            <th>User</th>
            <th>Risk</th>
            <th>Status</th>
            <th>Level</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {items.map((row: any) => (
            <tr key={row.approval_id}>
              <td>{row.user.name}</td>
              <td>{row.risk_score}</td>
              <td>
                <StatusBadge status={row.status} />
              </td>
              <td>{row.level}</td>
              <td>
                <button onClick={() => open(row)}>Review</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {active && (
        <ApprovalModal
          data={active}
          onClose={() => setActive(null)}
          refresh={load}
        />
      )}
    </div>
  );
}
